import { FC } from 'react';

interface VelxMarkIconProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

export const VelxMarkIcon: FC<VelxMarkIconProps> = ({
  className,
  width = 55,
  height = 50,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 55 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g clipPath="url(#velx-mark-clip)">
      <path
        d="M53.6255 5.05382C51.7889 1.88913 48.495 0 44.8164 0H10.1921C6.51355 0 3.21962 1.88913 1.38303 5.05382C-0.453553 8.21851 -0.453553 11.9968 1.38303 15.1615L18.6924 44.9462C20.529 48.1109 23.823 50 27.5015 50C31.1801 50 34.4741 48.1109 36.3106 44.9462L53.6201 15.1615C55.4566 11.9968 55.4566 8.21851 53.6201 5.05382H53.6255ZM16.9154 0.188375C17.1267 0.209903 17.3326 0.236814 17.5439 0.274489L45.1468 5.24758C47.9044 5.74273 50.1094 7.63186 51.2038 10.436C52.4498 13.6276 51.9352 17.2928 49.8548 20.0054L31.4781 44.0043C29.5386 46.5393 26.6347 47.7503 23.7146 47.2497C20.7457 46.7384 18.3836 44.5748 17.3922 41.4693L8.16593 12.4973C7.11491 9.19806 7.87338 5.55436 10.1488 2.98708C11.6007 1.35092 13.4536 0.382131 15.4202 0.188375H16.91H16.9154Z"
        fill="url(#velx-mark-grad-0)"
      />
      <path
        d="M51.2018 10.4518C50.1074 7.65314 47.897 5.76401 45.1449 5.26347L17.5419 0.295762C17.3307 0.258087 17.1248 0.231177 16.9135 0.209648C16.6643 0.182738 16.4151 0.171973 16.1659 0.171973C15.9167 0.171973 15.6674 0.182738 15.4236 0.209648C13.4516 0.403405 11.6042 1.37219 10.1523 3.00836C7.87686 5.57563 7.11839 9.21934 8.16941 12.5186L17.3957 41.4906C18.3871 44.5961 20.7492 46.7597 23.7181 47.271C26.6382 47.7769 29.542 46.5606 31.4816 44.0256L49.8582 20.0267C51.9386 17.3141 52.4533 13.6434 51.2072 10.4572L51.2018 10.4518ZM20.4079 42.8684C18.2733 41.9481 16.9243 39.5746 16.8864 36.6682L16.5343 10.8124C16.4909 7.50782 18.1 4.3808 20.6354 2.83613C21.5835 2.26024 22.5641 1.96961 23.523 1.96961C24.2869 1.96961 25.04 2.1526 25.7497 2.52396L44.0993 12.1149C45.7896 12.9976 46.9273 14.8168 47.2198 17.1042C47.6099 20.1289 46.4614 23.3528 44.2943 25.3065L26.2915 41.5713C24.4657 43.2183 22.3203 43.6919 20.4025 42.863L20.4079 42.8684Z"
        fill="url(#velx-mark-grad-1)"
      />
      <path
        d="M47.2198 17.1098C46.9272 14.8224 45.7895 13.0033 44.0992 12.1206L25.7496 2.52963C25.0399 2.15826 24.2869 1.97527 23.523 1.97527C22.5641 1.97527 21.578 2.2659 20.6354 2.84179C18.0999 4.38646 16.4909 7.51886 16.5342 10.8181L16.8864 36.6739C16.9243 39.5748 18.2733 41.9537 20.4078 42.8741C22.3257 43.7029 24.4711 43.2293 26.2968 41.5824L44.2997 25.3176C46.4667 23.3585 47.6099 20.14 47.2252 17.1152L47.2198 17.1098ZM17.932 31.3994L24.4169 11.4424C25.3108 8.68678 27.3966 6.52855 29.477 6.18948C29.6558 6.16256 29.8345 6.14642 30.0079 6.14642C30.9181 6.14642 31.7091 6.55008 32.2779 7.30896L41.0545 19.1227C41.8672 20.2153 42.0947 21.8945 41.6775 23.7298C41.1304 26.1464 39.5863 28.3477 37.7497 29.3273L22.4882 37.4704C21.123 38.197 19.7902 38.1593 18.8313 37.3628C17.4715 36.2379 17.1139 33.8967 17.9266 31.3994H17.932Z"
        fill="url(#velx-mark-grad-2)"
      />
      <path
        d="M41.0549 19.1225L32.2783 7.30874C31.7148 6.54448 30.9184 6.1462 30.0083 6.1462C29.8349 6.1462 29.6561 6.16235 29.4773 6.18926C27.3915 6.52833 25.3111 8.68657 24.4172 11.4422L17.9323 31.3992C17.1197 33.8965 17.4772 36.2323 18.8371 37.3626C19.796 38.1591 21.1287 38.1968 22.494 37.4702L37.7555 29.327C39.5921 28.3475 41.1361 26.1516 41.6833 23.7296C42.1005 21.8943 41.8729 20.2151 41.0603 19.1225H41.0549ZM31.6769 30.9255L21.1775 32.4541C20.3811 32.5725 19.7472 32.3087 19.3951 31.7221C18.7287 30.6026 19.1838 28.6058 20.5111 26.862L29.862 14.5477C30.9834 13.073 32.4516 12.158 33.6218 12.158C33.8006 12.158 33.974 12.1796 34.1419 12.2226C34.8191 12.411 35.2417 12.9761 35.3338 13.8211L36.4878 24.6069C36.7532 27.0881 34.1094 30.5703 31.6931 30.9201L31.6769 30.9255Z"
        fill="url(#velx-mark-grad-3)"
      />
      <path
        d="M36.4721 24.6123L35.3182 13.8265C35.2261 12.9815 34.8035 12.411 34.1263 12.228C33.9638 12.185 33.7904 12.1634 33.6062 12.1634C32.436 12.1634 30.9678 13.0784 29.8463 14.5531L20.4955 26.8674C19.1736 28.6112 18.7131 30.608 19.3794 31.7275C19.7316 32.3141 20.3654 32.5779 21.1618 32.4594L31.6612 30.9309C34.0775 30.5811 36.7213 27.0988 36.4559 24.6177L36.4721 24.6123ZM29.0391 29.8168C28.6707 29.9675 28.3294 30.0429 28.0314 30.0429C27.8472 30.0429 27.6793 30.0106 27.533 29.9514L22.2887 27.7501C21.9962 27.6263 21.8336 27.4002 21.8065 27.0719C21.7469 26.3346 22.4242 25.0859 23.8057 24.2302L32.0296 19.1118C33.0102 18.5036 33.9475 18.3636 34.4188 18.7565C34.7385 19.0256 34.7818 19.5047 34.538 20.1075L31.5583 27.4272C31.1682 28.3852 30.1335 29.3701 29.0445 29.8222L29.0391 29.8168Z"
        fill="url(#velx-mark-grad-4)"
      />
    </g>
    <defs>
      <linearGradient
        id="velx-mark-grad-0"
        x1="55.0016"
        y1="25"
        x2="0.00153112"
        y2="25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026846" />
        <stop offset="0.19" stopColor="#037D4F" />
        <stop offset="0.58" stopColor="#06B467" />
        <stop offset="0.99" stopColor="#0BF684" />
      </linearGradient>
      <linearGradient
        id="velx-mark-grad-1"
        x1="51.8736"
        y1="23.7726"
        x2="7.69808"
        y2="23.7726"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026846" />
        <stop offset="0.41" stopColor="#06AC63" />
        <stop offset="0.77" stopColor="#09E17B" />
        <stop offset="0.94" stopColor="#0BF684" />
      </linearGradient>
      <linearGradient
        id="velx-mark-grad-2"
        x1="47.2956"
        y1="22.6211"
        x2="16.5288"
        y2="22.6211"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026846" />
        <stop offset="0.14" stopColor="#026B47" />
        <stop offset="0.31" stopColor="#038251" />
        <stop offset="0.68" stopColor="#07BD6B" />
        <stop offset="0.99" stopColor="#0BF684" />
      </linearGradient>
      <linearGradient
        id="velx-mark-grad-3"
        x1="41.8838"
        y1="22.0612"
        x2="17.5043"
        y2="22.0612"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026846" />
        <stop offset="0.14" stopColor="#026D48" />
        <stop offset="0.31" stopColor="#037C4E" />
        <stop offset="0.51" stopColor="#049559" />
        <stop offset="0.71" stopColor="#07B869" />
        <stop offset="0.92" stopColor="#09E47C" />
        <stop offset="0.99" stopColor="#0BF684" />
      </linearGradient>
      <linearGradient
        id="velx-mark-grad-4"
        x1="36.4884"
        y1="22.3195"
        x2="19.0869"
        y2="22.3195"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026846" />
        <stop offset="0.15" stopColor="#026C48" />
        <stop offset="0.32" stopColor="#037A4D" />
        <stop offset="0.5" stopColor="#049057" />
        <stop offset="0.68" stopColor="#06B065" />
        <stop offset="0.87" stopColor="#09D876" />
        <stop offset="0.99" stopColor="#0BF684" />
      </linearGradient>
      <clipPath id="velx-mark-clip">
        <rect width="55" height="50" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
